import type { CourierType } from '@/domains/mobile-web/constant/listStatusCourier.constant';
import type { AdminProductAvailability } from '../types/adminProduct.types';

/** Badge colours (STATUS_COURIER key) per availability; the label itself comes from the API. */
export const PRODUCT_STATUS_BADGE: Record<AdminProductAvailability, CourierType> = {
  preorder: 'preOrder',
  available: 'available',
  unavailable: 'Unavailable',
};

/** Status options: the list's Semua Status filter and the form's Status field. */
export const PRODUCT_STATUS_OPTIONS: { value: AdminProductAvailability; label: string }[] = [
  { value: 'preorder', label: 'Pre-Order' },
  { value: 'available', label: 'Tersedia' },
  { value: 'unavailable', label: 'Tidak Tersedia' },
];
